import { api } from './apiClient';

export const getKarmaCoinsConfig = async () => {
    try {
        const response = await api.get('/api/v1/admin/karma-coins-config');
        return response.data;
    } catch (error) {
        if (error.response) {
            const message = error.response.data?.message || `Server error: ${error.response.status}`;
            throw new Error(message);
        } else if (error.request) {
            throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
        } else {
            throw new Error(error.message || 'An unexpected error occurred');
        }
    }
};

export const updateKarmaCoinsConfig = async (configData) => {
    try {
        const response = await api.put('/api/v1/admin/karma-coins-config', configData);
        return response.data;
    } catch (error) {
        if (error.response) {
            const message = error.response.data?.message || `Server error: ${error.response.status}`;
            throw new Error(message);
        } else if (error.request) {
            throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
        } else {
            throw new Error(error.message || 'An unexpected error occurred');
        }
    }
};
